// Mock data for BlissCare landing page

export const mockData = {
  company: {
    name: "BlissCare",
    tagline: "We care when you can't be there",
    location: "Pune, Maharashtra",
    phone: "+919834462988",
    whatsapp: "+919834462988",
    email: "care@blisscare.in",
    address: "Shop no 43, Aditya Shagun Mall, NDA - Pashan Road, Bavdhan,\n Pune - 411021\nIndia"
  },
  
  hero: {
    headline: "Your Parents Deserve Care, Even When You're Not There",
    subheadline: "A structured, reliable support system for elderly parents in Pune — with real-time updates, on-ground help, and immediate action when needed.",
    image: "https://images.unsplash.com/photo-1580869318757-a6c605b061ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxlbGRlcmx5JTIwY2FyZXxlbnwwfHx8fDE3NzQ5NTA5Mzd8MA&ixlib=rb-4.1.0&q=85"
  },

  problems: [
    {
      title: "No Visibility",
      description: "You don’t know what’s happening in their daily life",
      icon: "home"
    },
    {
      title: "No Trusted Person",
      description: "No reliable person on ground to handle real situations",
      icon: "heart-pulse"
    },
    {
      title: "No Immediate Action",
      description: "In emergencies, every minute matters — but who will respond?",
      icon: "users"
    },
    {
      title: "Unspoken Problems",
      description: "Parents often don’t share health or daily struggles clearly",
      icon: "alert-circle"
    }
  ],

  services: [
    {
      title: "Monitoring & Check-ins",
      description: "We help with everyday tasks so your parents can live comfortably and independently",
      image: "https://images.pexels.com/photos/7551675/pexels-photo-7551675.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      features: [
        "Daily check-in calls",
        "Wellbeing tracking",
        "Verified updates to family",
      ]
    },
    {
      title: "On-Ground Support",
      description: "Professional healthcare support from doctor visits to emergency response",
      image: "https://images.pexels.com/photos/11030158/pexels-photo-11030158.jpeg",
      features: [
        "Bank & documentation work",
        "Government/office visits",
        "Grocery & essential errands",
      ]
    },
    {
      title: "Visits & Assistance",
      description: "Regular companionship and care that makes them feel valued and loved",
      image: "https://images.unsplash.com/photo-1765896387377-e293914d1e69",
      features: [
        "Scheduled home visits",
        "Emergency visits",
        "Real-life support when required",
      ]
    },
    {
      title: "Emergency Handling",
      description: "Regular companionship and care that makes them feel valued and loved",
      image: "https://images.unsplash.com/photo-1765896387377-e293914d1e69",
      features: [
        "Immediate response system",
        "Coordination with hospitals/family",
        "Priority action in urgent cases",
      ]
    }
  ],

  howItWorks: [
    {
      step: 1,
      title: "Connect With Us",
      description: "Call, WhatsApp, or fill our form. We understand your concerns and your parents' needs.",
      icon: "phone"
    },
    {
      step: 2,
      title: "Meet Your Care Manager",
      description: "We assign a dedicated, verified care manager who will be your parents' trusted companion.",
      icon: "user-check"
    },
    {
      step: 3,
      title: "Stay Connected",
      description: "Receive daily updates, photos, and reports. Video call anytime to see your parents happy and cared for.",
      icon: "video"
    }
  ],

  trustFactors: [
    {
      title: "Verified Staff",
      description: "All our care managers undergo thorough background checks and training",
      icon: "shield-check"
    },
    {
      title: "Real-Time Updates",
      description: "Daily photos, videos, and reports so you're always in the loop",
      icon: "smartphone"
    },
    {
      title: "Local Pune Presence",
      description: "We know Pune inside-out - from hospitals to the best grocery stores",
      icon: "map-pin"
    },
    {
      title: "24/7 Emergency Response",
      description: "Round-the-clock support for any urgent situations",
      icon: "clock"
    }
  ],

  pricing: [
    {
      name: "Essential Care",
      price: "₹4,999",
      period: "per month",
      description: "Perfect for parents who need occasional support",
      features: [
        "4 visits per month (2-3 hours each)",
        "Daily assistance with errands",
        "Weekly health check-ins",
        "WhatsApp support",
        "Monthly family report"
      ],
      popular: false
    },
    {
      name: "Complete Care",
      price: "₹9,999",
      period: "per month",
      description: "Most popular for comprehensive daily support",
      features: [
        "12 visits per month (2-3 hours each)",
        "Daily assistance & medical coordination",
        "Doctor visit accompaniment",
        "Daily photo/video updates",
        "Priority emergency support",
        "Dedicated care manager"
      ],
      popular: true
    },
    {
      name: "Premium Care",
      price: "₹18,999",
      period: "per month",
      description: "Full-time peace of mind for your parents",
      features: [
        "Daily visits (3-4 hours)",
        "Complete daily living support",
        "All medical care coordination",
        "Real-time updates & alerts",
        "24/7 emergency response",
        "Dedicated senior care manager",
        "Monthly health reports"
      ],
      popular: false
    }
  ],

  faqs: [
    {
      question: "What happens if my parent doesn’t respond?",
      answer: "We escalate immediately — including calling, contacting backups, and doing a physical visit if required."
    },
    {
      question: "Can I customize the services based on my parents' needs?",
      answer: "Yes. We recommend plans, but services can be adjusted based on your parents' needs."
    },
    {
      question: "What if there’s an emergency?",
      answer: "We act immediately, visit physically if needed, and coordinate with hospitals and family."
    },
    {
      question: "Are you a medical or nursing service?",
      answer: "We are not a medical or nursing service. However, if required, we can arrange and coordinate trusted medical or nursing support whenever your parents need it."
    },
    {
      question: "Do you provide services across Pune?",
      answer: "Yes, we operate across Pune with local expertise."
    },
    {
      question: "Are there any extra charges?",
      answer: "Yes, additional visits or tasks beyond your plan may be charged separately."
    },
    {
      question: "Can I try before committing long-term?",
      answer: "Yes, you can start with a monthly plan."
    }
  ],

  testimonials: [
    {
      name: "Priya Sharma",
      location: "Daughter, Living in Dubai",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop",
      text: "I was constantly worried about my mother living alone in Pune. BlissCare has been a blessing. They treat her like family, and I get daily updates. It's like I'm there with her.",
      rating: 5
    },
    {
      name: "Rajesh Kulkarni",
      location: "Son, Living in USA",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop",
      text: "When Dad had a health scare, BlissCare's team was there within minutes. They coordinated everything with the hospital. I can't thank them enough for their prompt response.",
      rating: 5
    },
    {
      name: "Sneha Desai",
      location: "Daughter, Living in Bangalore",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
      text: "My parents actually look forward to the care manager's visits now. They've become friends! The emotional support is as valuable as the practical help.",
      rating: 5
    }
  ],

  story: {
    headline: "When Distance Doesn't Mean Absence",
    text: `Mr. Hiwarkar's son moved to Europe with her beloved Girlfriend for love one year ago. Every call home was filled with worry - Are they eating properly? Did they remember their medicines? Who will help if something happens? Well obivously, Shatanand didn't thought about this when choosing her Love over Parents but no worries he found BlissCare, everything changed. Now Mr. Hiwarkar has a dedicated care manager who visits him three times a week, helps with routine, accompanies him to doctor visits, and simply sits and chats over tea. His son receives daily photos and updates. 'I finally sleep regretting at night about choosing love over parents,' he says. 'It's like having a family member there with him.'\n\n- Shatanand Hiwarkar`,
    image: "https://images.pexels.com/photos/7551675/pexels-photo-7551675.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  }
};
